export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              每日更新 · 全部免费
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              包子漫画 —— 免费漫画全集阅读平台
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              海量韩漫、日漫、国漫资源一站收录，每日同步更新热门连载，下拉式流畅阅读体验，无需注册付费即可畅读全部内容。当前热推《女神降临》《我独自升级》《修罗武神》等千万人气作品，追更永不断档。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-6 mb-7">
              <div className="flex items-center gap-1.5">
                <span className="font-heading text-2xl text-primary-500">10万+</span>
                <span className="text-xs text-foreground-500">漫画资源</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="font-heading text-2xl text-primary-500">每日更新</span>
                <span className="text-xs text-foreground-500">追更不停</span>
              </div>
              <div className="w-px h-5 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-1.5">
                <span className="font-heading text-2xl text-primary-500">500万+</span>
                <span className="text-xs text-foreground-500">月活用户</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                开始免费阅读
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full text-sm font-medium hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-line"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20collage%20style%20illustration%20of%20popular%20manga%20and%20manhwa%20characters%20in%20dynamic%20action%20poses%2C%20Korean%20webtoon%20and%20Japanese%20manga%20art%20style%20blend%2C%20warm%20energetic%20color%20palette%20with%20coral%20orange%20and%20golden%20accents%2C%20comic%20speech%20bubbles%2C%20reading%20theme%2C%20digital%20art%2C%20clean%20composition%2C%20joyful%20atmosphere&width=1040&height=780&seq=hero-main&orientation=landscape"
                alt="包子漫画 - 海量免费漫画阅读平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}